import { css } from '@emotion/css';
import { CardLayout, MTypography } from 'src/lib';
import { ScreenBreakpoint, TextAlign } from 'src/styles';

const expiredLinkText = css`
  && {
    ${TextAlign.center}
  }
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    && {
      ${TextAlign.left}
    }
  }
`;

export const OfferCardPaymentAccountLinkExpire = () => {
  return (
    <CardLayout
      cardTitle='Link Expired'
      cardSubtitle={
        <>
          <MTypography variant='subtitle1' className={expiredLinkText}>
            Your Stripe Connect account confirmation link has expired. Please email{' '}
            <a href='mailto:jv@cambriacapital.com'>jv@cambriacapital.com</a> to request a new link.
          </MTypography>
        </>
      }></CardLayout>
  );
};
